// @refresh skip
// @ts-ignore
import App from "#start/app";
import { ErrorBoundary } from "../shared/ErrorBoundary";
import "./mount";
function Dummy(props) {
    return props.children;
}
/**
 *
 * Read more: https://docs.solidjs.com/solid-start/reference/client/start-client
 */
export function StartClient() {
    return (<Dummy>
      <Dummy>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Dummy>
    </Dummy>);
}
